<template>
  <div>
  <div class="black-overlay"></div>
  <div class="modal modal--welcomeback modal--zero-balance" id="welcome_modal">
    <div class="modal__content">
      <button class="btn modal-close"><i class="icon-close"></i></button>
      <div class="modal__header modal_ti_header">
      </div>
      <div class="modal__body">
        <h1>{{ getTranslations.home_modals_zero_balance_zero_game_balance }}</h1>
        <img class="modal_icon_alert" src="static/images/modals/zero_coins.png" alt="" >
        <p>{{ getTranslations.home_modals_zero_balance_unlock_more_games_msg }}</p>
      <div class="modal__footer">
        <a v-if="!hideStore"> <div style="cursor:pointer" class="ti_btn--main" @click.prevent="toBundlesPage">{{ getTranslations.home_modals_zero_balance_unlock_games }}</div></a>
      </div>
      </div>
    </div>
  </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  name: 'zero-balance',
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    toBundlesPage() {
      this.storeModalForHomePage(null);
      this.$router.push('/home/store');
    },
  },
  computed: {
    ...mapState('common', [
      'hideStore',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ZeroBalance.vue